import { render, staticRenderFns } from "./ProsesView.vue?vue&type=template&id=08acc01c&"
import script from "./ProsesView.vue?vue&type=script&lang=js&"
export * from "./ProsesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports